export const LOADING_ROLE = "LOADING_ROLE";
export const GET_ROLE_LIST = "GET_ROLE_LIST";
export const REMOVE_ROLE = "REMOVE_ROLE";
export const ADD_ROLE = "ADD_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";